module.exports = __webpack_public_path__ + "static/media/app-preview.553efa8a.png";